import renderPage from '../../config/renderPage';
import { eventsLogger } from '../analytics/eventLogger';
import { preGa } from '../analytics/preGa';
import SignIn from './components/SignIn';
import { BASE_PATH, PAGE_NAME } from './constants';
import reducers from './reducers';

renderPage({
    reducers: reducers,
    initialState: window.__REDUX_STATE__,
    routes: [
        {
            path: BASE_PATH,
            component: SignIn,
        },
    ],
    pageName: PAGE_NAME,
    postGaCustomMiddleware: [eventsLogger],
    preGaCustomMiddleware: [preGa],
});
